<template>

    <!-- bg gray-->
    <div class="lc_modalMask" :style="{'zIndex' : gv_zIndex.app_newVersionMsg}"
         v-if="co_newWebVersionIsAvailable_b || co_newAndroidVersionIsAvailable_b || co_newIosVersionIsAvailable_b">

        <!-- center -->
        <div class="lc_modalWrapper">

            <!-- container-->
            <div class="lc_modalContainer TQ_maxWidth_600px TQ_center TQ_scrollable" >

                <!-- 1) title -->
                <div class="TQ_text_24px TQ_border_bottom TQ_padding_12px TQ_bg_purple_dark TQ_text_capitalize">
                    {{ass_strings.fourWords_newUpdateIsAvailable[p_system_langCode_e]}}
                </div>

                <!-- 2) body -->
                <div>

                    <!-- 2.1) app version body -->
                    <div v-if="co_newAndroidVersionIsAvailable_b || co_newIosVersionIsAvailable_b"></div>

                    <!-- 2.2) web version body -->
                    <tq-loader-container v-else-if="co_newWebVersionIsAvailable_b || co_newWebVersionUpdateInProgress_b" :p_show-loader_b="server_versionInfo_c=== undefined"
                                         :p_tq-loader_b="true" class="TQ_padding_8px">


                        <fcc-display-slides-data v-if="server_versionInfo_c"
                                                 p_slide-height_s="200px"
                                                 :p_slides-data_ac="server_versionInfo_c.so_slides_blc_ac[server_versionInfo_c.ml_m_displayLang_fe(p_system_langCode_e)]"/>

                        <div v-else class="TQ_text_20px TQ_text_bold TQ_padding_4px TQ_text_capitalize_first_letter">
                            {{ass_strings.sentence_versionNoInfo[p_system_langCode_e]}}.
                        </div>
                    </tq-loader-container>


                </div>

                <!-- 3) update btn  -->
                <div class="TQ_border_top TQ_padding_4px">

                    <!-- progress -->
                    <div v-if="co_newWebVersionUpdateInProgress_b && progressServiceWorker_n < 100" class="TQ_margin_16px">
                        <div class="TQ_textAlign_initial">
                            {{ass_strings.sentence_updateInProgress[p_system_langCode_e]}}...
                        </div>
                        <tq-progress-bar :p_progress_n="progressServiceWorker_n / 100" class="TQ_border"/>
                    </div>

                    <!-- 3) update button -->
                    <div v-else-if="(co_newWebVersionUpdateInProgress_b && progressServiceWorker_n >= 100)
                        || (co_newWebVersionIsAvailable_b && server_versionInfo_c !== undefined && !co_newWebVersionUpdateInProgress_b)
                        || (co_newAndroidVersionIsAvailable_b || co_newIosVersionIsAvailable_b)">

                        <div class="TQ_borderRadius " @click="m_update_f">

                            <!-- 3.2) android -->
                            <tq-image   :pb_src_r="ass_img_googleStore"
                                        v-if="co_newAndroidVersionIsAvailable_b"
                                        class="TQ_maxWidth_150px TQ_clickable TQ_box_shadow TQ_padding_4px TQ_borderRadius TQ_bg_black"/>

                            <!-- 3.3) ios -->
                            <tq-image   :pb_src_r="ass_img_appStore"
                                        v-else-if="co_newIosVersionIsAvailable_b"
                                        class="TQ_maxWidth_150px TQ_clickable TQ_box_shadow TQ_padding_4px TQ_borderRadius TQ_bg_black" />

                            <!-- 3.3) web version -->
                            <div v-else
                                 class="TQ_bg_purple TQ_box_shadow TQ_borderRadius TQ_padding_8px TQ_center TQ_text_20px TQ_clickable TQ_width_150px TQ_grid_col_1frAuto">
                                <div class="TQ_grid_verticalCenter">
                                    {{ass_strings.oneWord_update[p_system_langCode_e]}}
                                </div>

                                <div class="TQ_grid_verticalCenter TQ_animation_beacon TQ_square_8px TQ_bg_circle"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {enum_langCodes, enum_runIn_es, enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import {gv_zIndex} from "@/scripts/S_GlobalVar";
import {webAppManager_startUpdate_f} from "@/scripts/S_WebAppMediator";
import {route_refreshPage} from "@/router";
import TqProgressBar from "../../components/basic2/TqProgressBar";
import {date_doEveryClockTick_addCb_f, date_doEveryClockTick_removeCb_f} from "@/scripts/S_Date";
import {FB_AndroidInfo, FB_ServerCurrentVersion, FB_UserData} from "../../../functions/src/shareCode/Share_S_Classes";
import {ass_img_appStore, ass_img_googleStore} from "@/assets/scripts/Ass_Files";
import {store_getStateValue_vo, store_var} from "@/store";
import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
import TqImage from "@/components/basic/TqImage";
import {serverPre_moreInfo_get_one_f} from "@/scripts/Server/S_ServerPre";
import FccDisplaySlidesData from "@/components/complex/TqDisplaySlidesData";

export default {
    name: "C_App_NewVersionApp",
    components: {FccDisplaySlidesData, TqImage, TqLoaderContainer, TqProgressBar},
    props:{
        p_localWebVersion_c:{
            type: Object,
            require: true
        },
        p_serverVersionInfo_c:{
            type: FB_ServerCurrentVersion,
            require: true
        },
        p_androidInfo_c :{
            type: FB_AndroidInfo,
            require: true,
        },
        p_iosVersion_s :{
            type: String,
            require: true,
        },
        p_serviceWorkerLoader_b:{
            type: Boolean,
            require: true,
        },
        p_system_langCode_e:{
            type: String,
            require: true,
            validator(langCode){
                return validator_enum_fb(enum_langCodes, langCode)
            }
        },
        p_currentUserData_c:{
            Type: FB_UserData,
            require:true
        },
    },
    data(){
        return {
            server_versionInfo_c : undefined,
            serviceWorkerExist_b : true,
            progressServiceWorker_n : 0,

            // imports
            gv_zIndex: gv_zIndex,
            ass_strings: ass_strings,
            ass_img_googleStore : ass_img_googleStore,
            ass_img_appStore : ass_img_appStore,
        }
    },
    computed:{
        co_newWebVersionIsAvailable_b(){

            // '2021.9.9'
            // this.p_serverVersionInfo_c.svi_webVersion_s = "2021_11_01"
            // this.p_localWebVersion_c.version = "2021.9.9"

            if(this.p_localWebVersion_c == null || this.p_serverVersionInfo_c == null){
                return false
            }

            return this.p_serverVersionInfo_c.svi_webVersion_s > this.p_localWebVersion_c.version

            // return this.p_serverVersionInfo_c.svi_m_newerWebVersion_f(this.p_localWebVersion_c.version)
        },
        co_newAndroidVersionIsAvailable_b(){
            if(this.p_androidInfo_c == null){
                return false
            }
            return this.p_serverVersionInfo_c.svi_androidVersion_s > this.p_androidInfo_c.ai_versionName_s
        },
        co_newIosVersionIsAvailable_b(){


            if(this.p_iosVersion_s == null){

                // todo: handler ios firstVersion, remove this in 12.1
                if( store_getStateValue_vo(store_var.system_runIn_e).val  === enum_runIn_es.ios_app ) {
                    return true
                }

                return false
            }

            return this.p_serverVersionInfo_c.svi_iosVersion_s > this.p_iosVersion_s
        },
        co_newWebVersionUpdateInProgress_b(){
            return this.p_serviceWorkerLoader_b && this.co_newWebVersionIsAvailable_b
        },
        co_firstLoad_b(){
            return this.p_serviceWorkerLoader_b && this.p_currentUserData_c == null
        },
    },
    methods:{
        m_update_f(){

            if(this.co_newAndroidVersionIsAvailable_b || this.co_newIosVersionIsAvailable_b){
                webAppManager_startUpdate_f(() => {})
            }else{
                route_refreshPage()
            }
        }
    },
    created(){

        date_doEveryClockTick_addCb_f(this.$options.name, () =>{
            this.progressServiceWorker_n += 4

            if(this.progressServiceWorker_n >= 100){
                date_doEveryClockTick_removeCb_f(this.$options.name)
            }
        },false)



        if(this.co_newWebVersionIsAvailable_b){

            serverPre_moreInfo_get_one_f({
                mi_id_uid: this.p_serverVersionInfo_c.svi_webVersion_s,
                cb_f : (versionMoreInfo_c) => {
                    this.server_versionInfo_c = versionMoreInfo_c
                }

            })
        }


    },
    destroyed(){
        date_doEveryClockTick_removeCb_f(this.$options.name)
    }
}
</script>

<style scoped lang="scss">
.lc_modalMask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;

    .lc_modalWrapper {
        display: table-cell;
        vertical-align: middle;

        .lc_modalContainer {
            margin: 0px auto;
            background-color: #fff;
            border-radius: 5px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
            transition: all .3s ease;
            font-family: Helvetica, Arial, sans-serif;
            max-height: 90vh;
            position: relative;

        }
    }
}
</style>